// eslint-disable-next-line @tseslint/typedef
export const OVERLAY_POSITIONS = {
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right"
} as const;
export type OverlayPosition = typeof OVERLAY_POSITIONS[keyof typeof OVERLAY_POSITIONS];
// eslint-disable-next-line @tseslint/typedef
export const TRIGGER_MODES = {
  click: "click",
  hover: "hover"
} as const;
export type TriggerModes = typeof TRIGGER_MODES[keyof typeof TRIGGER_MODES];
// eslint-disable-next-line @tseslint/typedef
export const OVERLAY_ALIGNMENTS = {
  start: "start",
  end: "end",
  center: "center"
} as const;
export type OverlayAlignment = typeof OVERLAY_ALIGNMENTS[keyof typeof OVERLAY_ALIGNMENTS];
// eslint-disable-next-line @tseslint/typedef
export const POSITION_TYPES = {
  "static": "static",
  relative: "relative",
  fixed: "fixed",
  absolute: "absolute",
  sticky: "sticky"
} as const;
export type PositionType = typeof POSITION_TYPES[keyof typeof POSITION_TYPES];
// eslint-disable-next-line @tseslint/typedef
export const DISPLAY = {
  block: "block",
  inlineBlock: "inline-block",
  none: "none",
  flex: "flex",
  grid: "grid"
} as const;
export type Display = typeof DISPLAY[keyof typeof DISPLAY];
// eslint-disable-next-line @tseslint/typedef
export const VISIBILITY = {
  visible: "visible",
  hidden: "hidden",
  collapse: "collapse",
  inherit: "inherit"
} as const;
export type Visibility = typeof VISIBILITY[keyof typeof VISIBILITY];
// eslint-disable-next-line @tseslint/typedef
export const POINTER_EVENTS = {
  none: "none",
  auto: "auto"
} as const;
export type PointerEvents = typeof POINTER_EVENTS[keyof typeof POINTER_EVENTS];
